import React, { Component } from 'react';
import { connect } from 'react-redux';
import { choseCurrentIndex ,choseBankOrCurrent} from '../action/productAction';
import Util from '../util';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import {bankCode} from '../BankCode';

class RedeemSuperFund extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fundLimit:'',
      isOk:false,
      active:1,//1活期通 2银行
    };
  }
  componentWillMount() {
    document.title = "选择赎回渠道"
  }
  choseCurrent(i){
    let { dispatch } = this.props;
    dispatch(choseCurrentIndex(i))
    dispatch(choseBankOrCurrent(false))
    hashHistory.goBack()
  }
  render(){
    const { 
      selectCurrentIndex,//活期通位置
      selectBankIndex,//银行位置
    }=this.props;
    let { active  } = this.state;
    let icon=[require('../img/circleHookG.png'),require('../img/circleHookO.png')];
    return (
        <div className="container" >
          <NavigatorMain>
          <div className="header black">
            <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
            <div>选择赎回渠道</div>
            <div></div>
          </div>
          </NavigatorMain>
          <div className='content'>
            {
              this.props.location.state.dataSouse.map( (item,i)=> {
                return(
                  <div className='bankList' onClick={()=>this.choseCurrent(i)} key={i}>
                    <img src={ bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../img/bank.png')} className='img'/>
                    <div className='bankListTip'>
                      <p>{item.trustChannelName}</p>
                      <p>可赎回金额:{Util.parsePrice(item.canRedeemAmount)}元</p>
                      {
                        !item.allAmountCanUse ? <p style={{color:'rgb(104,113,126)',fontSize:10, paddingTop:2 }} >{ "部分成分基金暂停赎回/转换" } </p> : null
                      }
                    </div>
                    <div className='bankListRightOK'>
                      <img src={selectCurrentIndex===i?icon[1]:icon[0]} className='img'/>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    selectBankIndex:state.selectBankIndex,
    selectCurrentIndex:state.selectCurrentIndex,
    verifiedUserInfo: state.verifiedUserInfo,
  }
}
export default connect(mapStateToProps)(RedeemSuperFund);



// WEBPACK FOOTER //
// ./src/components/RedeemBankList.js